/* Inline SVG illustrations referenced by toolDocs.js `chart` field.
 * Lightweight, CSS-themable diagrams — no stock photos.
 */
import React from "react";

export const VsmIcon = () => (
  <svg viewBox="0 0 400 160" className="w-full h-auto" aria-hidden>
    <defs>
      <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
        <path d="M40 0H0V40" fill="none" stroke="#E2E8E3" strokeWidth="0.5" />
      </pattern>
    </defs>
    <rect width="400" height="160" fill="url(#grid)" />
    {[
      { x: 20, y: 30, label: "Receive" },
      { x: 110, y: 30, label: "Validate" },
      { x: 200, y: 60, label: "Adjudicate" },
      { x: 290, y: 60, label: "Approve" },
      { x: 290, y: 110, label: "Pay" },
    ].map((b, i) => (
      <g key={i}>
        <rect x={b.x} y={b.y} width="70" height="30" rx="4" fill="#9CA98D" />
        <text x={b.x + 35} y={b.y + 19} fontSize="10" fill="#fff" textAnchor="middle">{b.label}</text>
      </g>
    ))}
    {[[90, 45, 110, 45], [180, 45, 200, 75], [270, 75, 290, 75], [325, 90, 325, 110]].map((p, i) => (
      <line key={i} x1={p[0]} y1={p[1]} x2={p[2]} y2={p[3]} stroke="#5A6B5D" strokeWidth="1.5" markerEnd="url(#arrow)" />
    ))}
    <defs>
      <marker id="arrow" viewBox="0 0 10 10" refX="8" refY="5" markerWidth="6" markerHeight="6" orient="auto">
        <path d="M0 0 L10 5 L0 10 z" fill="#5A6B5D" />
      </marker>
    </defs>
  </svg>
);

export const SipocIcon = () => (
  <svg viewBox="0 0 400 140" className="w-full h-auto" aria-hidden>
    {["Suppliers", "Inputs", "Process", "Outputs", "Customers"].map((label, i) => (
      <g key={label}>
        <rect x={10 + i * 78} y={20} width="70" height="100" rx="4" fill={["#dbe6dc", "#e6dbdc", "#dce6db", "#e6e3db", "#dde2e6"][i]} stroke="#9CA98D" />
        <text x={45 + i * 78} y={45} fontSize="10" textAnchor="middle" fill="#3F4D40" fontWeight="600">{label[0]}</text>
        <text x={45 + i * 78} y={65} fontSize="9" textAnchor="middle" fill="#5A6B5D">{label.slice(1)}</text>
      </g>
    ))}
  </svg>
);

export const KanoIcon = () => (
  <svg viewBox="0 0 360 200" className="w-full h-auto" aria-hidden>
    <line x1="40" y1="180" x2="340" y2="180" stroke="#9CA98D" />
    <line x1="40" y1="20" x2="40" y2="180" stroke="#9CA98D" />
    <text x="180" y="195" fontSize="10" textAnchor="middle" fill="#5A6B5D">Feature delivery →</text>
    <text x="20" y="100" fontSize="10" textAnchor="middle" fill="#5A6B5D" transform="rotate(-90 20 100)">Satisfaction →</text>
    {/* Must-be: log curve approaching 0 */}
    <path d="M40 180 Q 130 120 340 100" stroke="#c75c5c" strokeWidth="2" fill="none" />
    <text x="345" y="105" fontSize="9" fill="#c75c5c">Must-be</text>
    {/* Performance: linear */}
    <line x1="40" y1="180" x2="340" y2="40" stroke="#5a8a72" strokeWidth="2" />
    <text x="345" y="45" fontSize="9" fill="#5a8a72">Performance</text>
    {/* Delighter: exponential */}
    <path d="M40 180 Q 240 175 340 25" stroke="#caa256" strokeWidth="2" fill="none" />
    <text x="345" y="25" fontSize="9" fill="#caa256">Delighter</text>
  </svg>
);

export const FishboneIcon = () => (
  <svg viewBox="0 0 400 180" className="w-full h-auto" aria-hidden>
    <line x1="40" y1="90" x2="340" y2="90" stroke="#5A6B5D" strokeWidth="2" />
    <polygon points="335,82 355,90 335,98" fill="#5A6B5D" />
    <text x="358" y="93" fontSize="10" fill="#3F4D40" fontWeight="600">Effect</text>
    {[["Manpower", 60, 45], ["Method", 140, 45], ["Machine", 220, 45]].map(([l, x, y], i) => (
      <g key={i}>
        <line x1={x} y1={y} x2={x + 30} y2={90} stroke="#9CA98D" />
        <text x={x} y={y - 4} fontSize="10" fill="#3F4D40">{l}</text>
      </g>
    ))}
    {[["Material", 60, 145], ["Measurement", 140, 145], ["Mother Nature", 220, 145]].map(([l, x, y], i) => (
      <g key={i}>
        <line x1={x} y1={y} x2={x + 30} y2={90} stroke="#9CA98D" />
        <text x={x} y={y + 14} fontSize="10" fill="#3F4D40">{l}</text>
      </g>
    ))}
  </svg>
);

export const ParetoIcon = () => (
  <svg viewBox="0 0 360 180" className="w-full h-auto" aria-hidden>
    <line x1="40" y1="160" x2="340" y2="160" stroke="#9CA98D" />
    <line x1="40" y1="20" x2="40" y2="160" stroke="#9CA98D" />
    {[80, 60, 40, 25, 18, 12, 8, 5].map((h, i) => (
      <rect key={i} x={50 + i * 35} y={160 - h} width="30" height={h} fill="#5a8a72" opacity={i < 4 ? 1 : 0.5} />
    ))}
    {/* cumulative line */}
    <polyline points="65,140 100,108 135,86 170,70 205,60 240,52 275,46 310,42" fill="none" stroke="#caa256" strokeWidth="2" />
    <line x1="40" y1="50" x2="340" y2="50" stroke="#c75c5c" strokeDasharray="3 3" />
    <text x="345" y="54" fontSize="9" fill="#c75c5c">80%</text>
  </svg>
);

export const RpnIcon = () => (
  <svg viewBox="0 0 360 140" className="w-full h-auto" aria-hidden>
    {[["S", "#5a8a72"], ["O", "#caa256"], ["D", "#c75c5c"]].map(([l, c], i) => (
      <g key={l}>
        <circle cx={60 + i * 90} cy="70" r="40" fill={c} opacity="0.85" />
        <text x={60 + i * 90} y="74" fontSize="22" fill="#fff" textAnchor="middle" fontWeight="700">{l}</text>
      </g>
    ))}
    <text x="285" y="74" fontSize="22" fill="#3F4D40" fontWeight="700">= RPN</text>
  </svg>
);

export const YamazumiIcon = () => (
  <svg viewBox="0 0 360 180" className="w-full h-auto" aria-hidden>
    <line x1="40" y1="160" x2="340" y2="160" stroke="#9CA98D" />
    {[
      { x: 60, h: 110, parts: [[40, "#5a8a72"], [40, "#caa256"], [30, "#c75c5c"]] },
      { x: 110, h: 90, parts: [[50, "#5a8a72"], [25, "#caa256"], [15, "#c75c5c"]] },
      { x: 160, h: 130, parts: [[60, "#5a8a72"], [40, "#caa256"], [30, "#c75c5c"]] },
      { x: 210, h: 70, parts: [[40, "#5a8a72"], [20, "#caa256"], [10, "#c75c5c"]] },
      { x: 260, h: 100, parts: [[55, "#5a8a72"], [30, "#caa256"], [15, "#c75c5c"]] },
    ].map((s, i) => {
      let acc = 0;
      return s.parts.map((p, j) => {
        const y = 160 - acc - p[0];
        acc += p[0];
        return <rect key={`${i}-${j}`} x={s.x} y={y} width="30" height={p[0]} fill={p[1]} />;
      });
    })}
    <line x1="40" y1="60" x2="340" y2="60" stroke="#3F4D40" strokeDasharray="3 3" />
    <text x="345" y="63" fontSize="9" fill="#3F4D40">Takt</text>
  </svg>
);

export const ImpactEffortIcon = () => (
  <svg viewBox="0 0 240 200" className="w-full h-auto" aria-hidden>
    <rect x="20" y="20" width="100" height="80" fill="#dbe6dc" />
    <rect x="120" y="20" width="100" height="80" fill="#caa256" opacity="0.3" />
    <rect x="20" y="100" width="100" height="80" fill="#e2e8e3" />
    <rect x="120" y="100" width="100" height="80" fill="#c75c5c" opacity="0.2" />
    <text x="70" y="55" fontSize="10" textAnchor="middle" fill="#3F4D40" fontWeight="700">Quick Wins</text>
    <text x="170" y="55" fontSize="10" textAnchor="middle" fill="#3F4D40" fontWeight="700">Big Bets</text>
    <text x="70" y="135" fontSize="10" textAnchor="middle" fill="#3F4D40" fontWeight="700">Fill-ins</text>
    <text x="170" y="135" fontSize="10" textAnchor="middle" fill="#3F4D40" fontWeight="700">Time Sinks</text>
    <text x="120" y="195" fontSize="9" textAnchor="middle" fill="#5A6B5D">Effort →</text>
    <text x="10" y="100" fontSize="9" textAnchor="middle" fill="#5A6B5D" transform="rotate(-90 10 100)">Impact →</text>
  </svg>
);

export const RadarIcon = () => (
  <svg viewBox="0 0 240 200" className="w-full h-auto" aria-hidden>
    <g transform="translate(120,100)">
      {[1, 2, 3, 4, 5].map((r) => (
        <polygon key={r} points={Array.from({ length: 6 }, (_, i) => {
          const a = (Math.PI / 3) * i - Math.PI / 2;
          return `${Math.cos(a) * r * 14},${Math.sin(a) * r * 14}`;
        }).join(" ")} fill="none" stroke="#E2E8E3" />
      ))}
      <polygon points={[3.5, 4, 2.5, 3, 4.5, 4].map((v, i) => {
        const a = (Math.PI / 3) * i - Math.PI / 2;
        return `${Math.cos(a) * v * 14},${Math.sin(a) * v * 14}`;
      }).join(" ")} fill="#5a8a72" opacity="0.4" stroke="#5a8a72" strokeWidth="2" />
      <polygon points={[5, 5, 4, 4.5, 5, 5].map((v, i) => {
        const a = (Math.PI / 3) * i - Math.PI / 2;
        return `${Math.cos(a) * v * 14},${Math.sin(a) * v * 14}`;
      }).join(" ")} fill="none" stroke="#caa256" strokeDasharray="3 3" strokeWidth="1.5" />
    </g>
  </svg>
);

export const CHART_MAP = {
  vsm: VsmIcon,
  sipoc: SipocIcon,
  kano: KanoIcon,
  fishbone: FishboneIcon,
  pareto: ParetoIcon,
  rpn: RpnIcon,
  yamazumi: YamazumiIcon,
  impact_effort: ImpactEffortIcon,
  radar: RadarIcon,
};
